module.exports = __webpack_public_path__ + "img/pd-img47.cffec0d2.jpg";